import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import FlightReportLegEditTab from './FlightReportLegEditTab';
import FlightReportLegAddTab from './FlightReportLegAddTab';
import moment from 'moment';
import getLocale from '../../../i18n/getLocale';

class FlightReportLegsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      deleting: false,
      flight_report_id: null,
      status: 0,
      departure_location_id: null,
      arrival_location_id: null,
      date: null,
      leg_number: null,
      takeoff_time_scheduled: null,
      total_time_scheduled: null,
      engine_start_time: null,
      start_parameter_total: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: '00:00',
      total_time: '00:00',
      navigation_time: '00:00',
      ifr_time: '00:00',
      night_time: '00:00',
      day_landings: 1,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: 35,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: '00:00',
      delay_departure: '00:00',  
      flight_report_legs: this.props.flight_report_legs,
      flight_report_legs_totals: this.props.flight_report_legs_totals,
      flight_report_legs_new: [],
      locations_select: [],
      ptbr_codes_select: [],
      ptbr_operations_select: [],
      ptbr_external_loads_select: [],
      staffs_select: [],
      duties_select: [],
      flight_report_leg_edit: {},
      flight_report_leg_edit_staffs: {},
    };

    this.saveAll = this.saveAll.bind(this);
    this.add = this.add.bind(this);
    this.addMobile = this.addMobile.bind(this);
    this.diffFlight = this.diffFlight.bind(this);
    this.diffTotalTime = this.diffTotalTime.bind(this);
    this.delayFlight = this.delayFlight.bind(this);
    this.delayTotalTime = this.delayTotalTime.bind(this);
    this.calcTimeFromMs = this.calcTimeFromMs.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.exportPtbrCode = this.exportPtbrCode.bind(this);
    this.setParentState = this.setParentState.bind(this);
    this.saveAdd = this.saveAdd.bind(this);
    this.setDeleteFalse = this.setDeleteFalse.bind(this);

    this.locale = getLocale();
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    if (name === 'takeoff_time') {
      this.diffFlight(event.target.value, this.state.landing_time, change);
      this.delayFlight(event.target.value, this.state.takeoff_time_scheduled, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'landing_time') {
      this.diffFlight(this.state.takeoff_time, event.target.value, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
    } else if (name === 'engine_start_time') {
      this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'engine_shutoff_time') {
      this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'takeoff_time_scheduled') {
      this.delayFlight(this.state.takeoff_time, event.target.value, change);
    } else if (name === 'total_time_scheduled') {
      this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
    } else {
      this.setState(change);
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  componentDidMount() {
    var flight_report_id = this.props.flight_report_id;
    let flight_report_legs_new_all = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};
    let flight_report_legs_new = flight_report_legs_new_all[flight_report_id] || [];
  
    this.setState({
      flight_report_legs_new: flight_report_legs_new
    });
  }

  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.flight_report_legs) || (this.state.loaded === 1 && newProps.updated === 1)) {
      var index = newProps.flight_report_legs.length-1;
      var start_parameter_total = null;
      var flight_report_id = newProps.flight_report_id;

      if (typeof newProps.flight_report_legs[index] !== 'undefined') {
        if (newProps.flight_report_legs[index].engine_shutoff_time === null || newProps.flight_report_legs[index].engine_shutoff_time === '' || typeof newProps.flight_report_legs[index].engine_shutoff_time === 'undefined') {
          start_parameter_total = newProps.flight_report_legs[index].landing_time;
        }
      }

      var flight_report_legs_new_all = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};

      var flight_report_legs_new = flight_report_legs_new_all[flight_report_id] || [];

      index = (Object.keys(flight_report_legs_new).length)-1;
      if (typeof flight_report_legs_new[index] !== 'undefined') {
        if (flight_report_legs_new[index].engine_shutoff_time === null || flight_report_legs_new[index].engine_shutoff_time === '' || typeof flight_report_legs_new[index].engine_shutoff_time === 'undefined') {
          start_parameter_total = flight_report_legs_new[index].landing_time;
        }
      }

      this.setState({
        flight_report_id: newProps.flight_report_id,
        flight_report_legs_new: flight_report_legs_new,
        flight_report_legs: newProps.flight_report_legs,
        flight_report_legs_totals: newProps.flight_report_legs_totals,
        locations_select: newProps.locations_select,
        ptbr_codes_select: newProps.ptbr_codes_select,
        ptbr_operations_select: newProps.ptbr_operations_select,
        ptbr_external_loads_select: newProps.ptbr_external_loads_select,
        staffs_select: newProps.staffs_select,
        duties_select: newProps.duties_select,
        date: newProps.flight_report.date_str,
        external_load: newProps.flight_report.contract.carga_externa,
        xml: newProps.flight_report.contract.xml,
        status: newProps.flight_report.status,
        start_parameter_total: start_parameter_total,
        loaded: 1,
      });
    }

    if(Array.isArray(newProps.flight_report_legs) || (this.state.loaded === 1 && newProps.updated === 0)) {
      var index = newProps.flight_report_legs.length-1;
      var start_parameter_total = null;
      var flight_report_id = newProps.flight_report_id;

      if (typeof newProps.flight_report_legs[index] !== 'undefined') {
        if (newProps.flight_report_legs[index].engine_shutoff_time === null || newProps.flight_report_legs[index].engine_shutoff_time === '' || typeof newProps.flight_report_legs[index].engine_shutoff_time === 'undefined') {
          start_parameter_total = newProps.flight_report_legs[index].landing_time;
        }
      }
      
      var flight_report_legs_new_all = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};

      var flight_report_legs_new = flight_report_legs_new_all[flight_report_id] || [];

      index = (Object.keys(flight_report_legs_new).length)-1;
      if (typeof flight_report_legs_new[index] !== 'undefined') {
        if (flight_report_legs_new[index].engine_shutoff_time === null || flight_report_legs_new[index].engine_shutoff_time === '' || typeof flight_report_legs_new[index].engine_shutoff_time === 'undefined') {
          start_parameter_total = flight_report_legs_new[index].landing_time;
        }
      }

      var departure_location_id = null;
      var fuel_start = 0;
      if (newProps.flight_report_legs.length > 0) {
        var index = newProps.flight_report_legs.length-1;
        departure_location_id = newProps.flight_report_legs[index].arrival_location_id;
        fuel_start = newProps.flight_report_legs[index].fuel_end;
      }

      if (Object.keys(flight_report_legs_new).length > 0) {
        index = (Object.keys(flight_report_legs_new).length)-1;
        departure_location_id = flight_report_legs_new[index].arrival_location_id;
        fuel_start = flight_report_legs_new[index].fuel_end;
      }

      this.setState({
        flight_report_id: newProps.flight_report_id,
        departure_location_id: departure_location_id,
        arrival_location_id: null,
        takeoff_time_scheduled: '',
        total_time_scheduled: '',
        engine_start_time: '',
        takeoff_time: '',
        landing_time: '',
        engine_shutoff_time: '',
        takeoff_land_time: '00:00',
        total_time: '00:00',
        navigation_time: '',
        ifr_time: '',
        night_time: '',
        day_landings: 1,
        night_landings: 0,
        starts: 0,
        pax: 0,
        payload: 0,
        external_load_long_line: 0,
        external_load_short_line: 0,
        fuel_start: fuel_start,
        fuel_end: 0,
        delay_time: '',
        delay_departure: '',
        ptbr_code_id: 35,
        ptbr_operation_id: null,
        ptbr_external_load_id: null,
        start_parameter_total: start_parameter_total,
      });
    }
  }

  // Fetch salvando a adição mobile
  addMobile(event) {
    event.preventDefault();
    this.add();
  }

  setDeleteFalse() {
    this.setState({deleting: false});
  }

  setParentState(index) {
    var flight_report_id = this.props.flight_report_id;
    var cached_flight_report_legs_states_new_by_id = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};
    var new_cached_flight_report_legs_states_new_by_id = [];
    var total_legs = (Object.keys(this.state.flight_report_legs).length) + 1;
  
    if (cached_flight_report_legs_states_new_by_id[flight_report_id]) {
      cached_flight_report_legs_states_new_by_id[flight_report_id].forEach((flight_report_leg_new, k) => {
        if(parseInt(k) !== parseInt(index)) {
          flight_report_leg_new.total_legs = total_legs;
          new_cached_flight_report_legs_states_new_by_id.push(flight_report_leg_new);
          total_legs += 1;
        }
      });
    }
  
    cached_flight_report_legs_states_new_by_id[flight_report_id] = new_cached_flight_report_legs_states_new_by_id;
    localStorage.setItem("cached_flight_report_legs_states_new_by_id", JSON.stringify(cached_flight_report_legs_states_new_by_id));
  
    this.setState({
      flight_report_legs_new: new_cached_flight_report_legs_states_new_by_id,
      deleting: true
    });
  }

  // Fetch salvando a adição
  add(toSave = false) {
    let takeoff_time_scheduled = null;
    let engine_start_time = null;
    let takeoff_time = null;
    let landing_time = null;
    let engine_shutoff_time = null;
    let engine_start_time_str = null;
    let takeoff_time_str = null;
    let landing_time_str = null;
    let engine_shutoff_time_str = null;
  
    if (this.state.takeoff_time_scheduled) takeoff_time_scheduled = this.state.date + ' ' + this.state.takeoff_time_scheduled;
    if (this.state.engine_start_time) engine_start_time = this.state.date + ' ' + this.state.engine_start_time;
    if (this.state.takeoff_time) takeoff_time = this.state.date + ' ' + this.state.takeoff_time;
    if (this.state.landing_time) landing_time = this.state.date + ' ' + this.state.landing_time;
    if (this.state.engine_shutoff_time) engine_shutoff_time = this.state.date + ' ' + this.state.engine_shutoff_time;
  
    if (takeoff_time_scheduled) takeoff_time_scheduled = moment(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");
    if (engine_start_time) engine_start_time = moment(engine_start_time, "DD/MM/YYYY HH:mm:ss");
    if (takeoff_time) takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
    if (landing_time) landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");
    if (engine_shutoff_time) engine_shutoff_time = moment(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");
    if (engine_start_time) engine_start_time_str = engine_start_time;
    if (takeoff_time) takeoff_time_str = takeoff_time;
    if (landing_time) landing_time_str = landing_time;
    if (engine_shutoff_time) engine_shutoff_time_str = engine_shutoff_time;
  
    if (takeoff_time_scheduled) {
      let diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');
      if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
        if (engine_start_time) engine_start_time.add(1, 'd');
        if (takeoff_time) takeoff_time.add(1, 'd');
        if (landing_time) landing_time.add(1, 'd');
        if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
        if (engine_start_time) engine_start_time_str.add(1, 'd');
        if (takeoff_time) takeoff_time_str.add(1, 'd');
        if (landing_time) landing_time_str.add(1, 'd');
        if (engine_shutoff_time) engine_shutoff_time_str.add(1, 'd');
      }
    }
  
    if (takeoff_time > landing_time) {
      if (landing_time) landing_time.add(1, 'd');
      if (landing_time) landing_time_str.add(1, 'd');
    }
  
    if (engine_start_time > engine_shutoff_time) {
      if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
      if (engine_shutoff_time) engine_shutoff_time_str.add(1, 'd');
    }
  
    if (engine_start_time) engine_start_time = engine_start_time.format("YYYY-MM-DD HH:mm:ss");
    if (takeoff_time) takeoff_time = takeoff_time.format("YYYY-MM-DD HH:mm:ss");
    if (landing_time) landing_time = landing_time.format("YYYY-MM-DD HH:mm:ss");
    if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("YYYY-MM-DD HH:mm:ss");
    if (engine_start_time_str) engine_start_time_str = engine_start_time_str.format("HH:mm");
    if (takeoff_time_str) takeoff_time_str = takeoff_time_str.format("HH:mm");
    if (landing_time_str) landing_time_str = landing_time_str.format("HH:mm");
    if (engine_shutoff_time_str) engine_shutoff_time_str = engine_shutoff_time_str.format("HH:mm");
    if (takeoff_time_scheduled) takeoff_time_scheduled = takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss");
  
    var datasave = {
      origin: 'Manual',
      flight_report_id: this.props.flight_report_id,
      departure_location_id: this.state.departure_location_id,
      arrival_location_id: this.state.arrival_location_id,
      takeoff_time_scheduled: takeoff_time_scheduled,
      total_time_scheduled: this.state.total_time_scheduled,
      engine_start_time: engine_start_time,
      takeoff_time: takeoff_time,
      landing_time: landing_time,
      engine_shutoff_time: engine_shutoff_time,
      takeoff_land_time: this.state.takeoff_land_time,
      total_time: this.state.total_time,
      navigation_time: this.state.navigation_time,
      ifr_time: this.state.ifr_time,
      night_time: this.state.night_time,
      day_landings: this.state.day_landings,
      night_landings: this.state.night_landings,
      starts: this.state.starts,
      pax: this.state.pax,
      payload: this.state.payload,
      external_load_long_line: this.state.external_load_long_line,
      external_load_short_line: this.state.external_load_short_line,
      fuel_start: this.state.fuel_start,
      fuel_end: this.state.fuel_end,
      delay_time: this.state.delay_time,
      delay_departure: this.state.delay_departure,
      ptbr_code_id: this.state.ptbr_code_id,
      ptbr_operation_id: this.state.ptbr_operation_id,
      ptbr_external_load_id: this.state.ptbr_external_load_id,
    };
    if(toSave) {
      if(navigator.onLine) {
        this.saveAdd(datasave)
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    } else {
      this.setState({start_parameter_total: landing_time});
      var flight_report_id = this.state.flight_report_id;
  
      var total_legs = 1;
  
      var cached_flight_report_legs_states_new_by_id = {};
      var new_index = 0;
      var flight_report_id = this.props.flight_report_id;
  
      if (localStorage.getItem("cached_flight_report_legs_states_new_by_id")) {
        cached_flight_report_legs_states_new_by_id = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id"));
        if (!cached_flight_report_legs_states_new_by_id[flight_report_id]) {
          cached_flight_report_legs_states_new_by_id[flight_report_id] = [];
        }
        total_legs += cached_flight_report_legs_states_new_by_id[flight_report_id].length;
        new_index = total_legs - 1;
      } else {
        cached_flight_report_legs_states_new_by_id[flight_report_id] = [];
      }
  
      cached_flight_report_legs_states_new_by_id[flight_report_id][new_index] = {
        origin: 'Manual',
        flight_report_id: flight_report_id,
        departure_location_id: this.state.departure_location_id,
        arrival_location_id: this.state.arrival_location_id,
        takeoff_time_scheduled: takeoff_time_scheduled,
        total_time_scheduled: this.state.total_time_scheduled,
        engine_start_time: engine_start_time,
        takeoff_time: takeoff_time,
        landing_time: landing_time,
        engine_shutoff_time: engine_shutoff_time,
        engine_start_time_str: engine_start_time_str,
        takeoff_time_str: takeoff_time_str,
        landing_time_str: landing_time_str,
        engine_shutoff_time_str: engine_shutoff_time_str,
        takeoff_land_time: this.state.takeoff_land_time,
        total_time: this.state.total_time,
        navigation_time: this.state.navigation_time,
        ifr_time: this.state.ifr_time,
        night_time: this.state.night_time,
        day_landings: this.state.day_landings,
        night_landings: this.state.night_landings,
        starts: this.state.starts,
        pax: this.state.pax,
        payload: this.state.payload,
        external_load_long_line: this.state.external_load_long_line,
        external_load_short_line: this.state.external_load_short_line,
        fuel_start: this.state.fuel_start,
        fuel_end: this.state.fuel_end,
        delay_time: this.state.delay_time,
        delay_departure: this.state.delay_departure,
        ptbr_code_id: this.state.ptbr_code_id,
        ptbr_operation_id: this.state.ptbr_operation_id,
        ptbr_external_load_id: this.state.ptbr_external_load_id,
        xml: this.state.xml,
      };
  
      this.setState({flight_report_legs_new: cached_flight_report_legs_states_new_by_id[flight_report_id]});
  
      this.setState({
        departure_location_id: this.state.arrival_location_id,
        arrival_location_id: null,
        takeoff_time_scheduled: '',
        total_time_scheduled: '',
        engine_start_time: '',
        takeoff_time: '',
        landing_time: '',
        engine_shutoff_time: '',
        takeoff_land_time: '00:00',
        total_time: '00:00',
        navigation_time: '',
        ifr_time: '',
        night_time: '',
        day_landings: 1,
        night_landings: 0,
        starts: 0,
        pax: 0,
        payload: 0,
        external_load_long_line: 0,
        external_load_short_line: 0,
        fuel_start: this.state.fuel_end,
        fuel_end: 0,
        delay_time: '',
        delay_departure: '',
        ptbr_code_id: 35,
        ptbr_operation_id: null,
        ptbr_external_load_id: null,
      });
  
      localStorage.setItem("cached_flight_report_legs_states_new_by_id", JSON.stringify(cached_flight_report_legs_states_new_by_id));
    }
  }

  saveAdd(datasave) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo/trecho', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  diffFlight(takeoff_time, landing_time, change) {
    if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
      takeoff_time = this.state.date + ' ' + takeoff_time;
      landing_time = this.state.date + ' ' + landing_time;

      takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");

      if (takeoff_time > landing_time) {
        landing_time.add(1, 'd');
      }

      takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss"));
      landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss"));
      let diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());
      if (landing_time > takeoff_time) {
        change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
        change['navigation_time'] = this.calcTimeFromMs(diffTime);
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
    } else {
      change['takeoff_land_time'] = '00:00';
      change['navigation_time'] = '00:00';
    }
    this.delayTotalTime(this.state.total_time_scheduled, change['takeoff_land_time'], change);
  }

  diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
    let start = null;
    if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
      start = engine_start_time;
    } else if (start_parameter_total !== null) {
      start = start_parameter_total.substring(11);
    }

    let finish = null;
    if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
      finish = landing_time;
    }
    if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
      finish = engine_shutoff_time;
    }

    if(start && finish) {
      start = this.state.date + ' ' + start;
      finish = this.state.date + ' ' + finish;

      start = moment(start, "DD/MM/YYYY HH:mm:ss");
      finish = moment(finish, "DD/MM/YYYY HH:mm:ss");

      if (start > finish) {
        finish.add(1, 'd');
      }

      start = new Date(start.format("YYYY-MM-DD HH:mm:ss"));
      finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss"));

      let diffTime = Math.abs(finish.getTime() - start.getTime());
      if (finish > start) {
        change['total_time'] = this.calcTimeFromMs(diffTime);
      } else {
        change['total_time'] = '00:00';
      }

      this.setState(change);
    } else {
      change['total_time'] = '00:00';
      this.setState(change);
    }
  }

  delayFlight(takeoff_time, takeoff_time_scheduled, change) {
    if(takeoff_time_scheduled) {
      takeoff_time = this.state.date + ' ' + takeoff_time;
      takeoff_time_scheduled = this.state.date + ' ' + takeoff_time_scheduled;

      takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      takeoff_time_scheduled = moment(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");

      let diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');

      if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
        takeoff_time.add(1, 'd');
      }

      takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
      takeoff_time_scheduled = new Date(takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
      let diffTime = Math.abs(takeoff_time.getTime() - takeoff_time_scheduled.getTime());
      if (takeoff_time > takeoff_time_scheduled) {
        change['delay_departure'] = this.calcTimeFromMs(diffTime);
      } else {
        change['delay_departure'] = '00:00';
      }
    } else {
      change['delay_departure'] = '00:00';
    }
    this.setState(change);
  }

  delayTotalTime(total_time_scheduled, takeoff_land_time, change) {
    if(takeoff_land_time && total_time_scheduled) {
      takeoff_land_time = moment().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
      total_time_scheduled = moment().format("YYYY-MM-DD") + ' ' + total_time_scheduled;
      takeoff_land_time = new Date(takeoff_land_time.replace(/ /g,"T"));
      total_time_scheduled = new Date(total_time_scheduled.replace(/ /g,"T"));
      let diffTime = Math.abs(takeoff_land_time.getTime() - total_time_scheduled.getTime());
      if (takeoff_land_time > total_time_scheduled) {
        change['delay_time'] = this.calcTimeFromMs(diffTime);
      } else {
        change['delay_time'] = '00:00';
      }
    } else {
      change['delay_time'] = '00:00';
    }
    this.setState(change);
  }

  calcTimeFromMs(diffTime) {
    diffTime = diffTime/1000;
    var secs = diffTime % 60;
    diffTime = (diffTime - secs) / 60;
    var mins = diffTime % 60;
    var hrs = (diffTime - mins) / 60;
    if (secs < 10) { secs = '0' + secs; }
    if (mins < 10) { mins = '0' + mins; }
    if (hrs < 10) { hrs = '0' + hrs; }
    return hrs + ':' + mins + ':' + secs ;
  }

  exportPtbrCode() {
    if(navigator.onLine) {
      var self = this;
      var url = "/exportar/codigos/ptbr";
      var header = this.refs.request_api.header('application/json');
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url , { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = config.get('cdn') + '/tmp/' + responseJson.data;
            window.open(config.get('cdn') + '/tmp/' + responseJson.data);
            self.props.handleAlert('', '', 'closed');
          }
        });
      });
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }    
  }

  saveAll() {
    var self = this;
    if(navigator.onLine) {
      var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.confirmarSalvarTodos);
      if(confirm) {
        var data_legs = [];
        var flight_report_leg_ids = [];
        var last_leg_number = 0;
        {Object.keys(self.state.flight_report_legs).map(function(k) {
          var srl = self.state.flight_report_legs[k];
          var ref = 'child_leg_' + srl.leg_number;
          flight_report_leg_ids.push(srl.id); 
          let takeoff_time_scheduled = null;
          let engine_start_time = null;
          let takeoff_time = null;
          let landing_time = null;
          let engine_shutoff_time = null;
      
          if (self[ref].state.takeoff_time_scheduled) takeoff_time_scheduled = self[ref].state.date + ' ' + self[ref].state.takeoff_time_scheduled;
          if (self[ref].state.engine_start_time) engine_start_time = self[ref].state.date + ' ' + self[ref].state.engine_start_time;
          if (self[ref].state.takeoff_time) takeoff_time = self[ref].state.date + ' ' + self[ref].state.takeoff_time;
          if (self[ref].state.landing_time) landing_time = self[ref].state.date + ' ' + self[ref].state.landing_time;
          if (self[ref].state.engine_shutoff_time) engine_shutoff_time = self[ref].state.date + ' ' + self[ref].state.engine_shutoff_time;
      
          if (takeoff_time_scheduled) takeoff_time_scheduled = moment(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");
          if (engine_start_time) engine_start_time = moment(engine_start_time, "DD/MM/YYYY HH:mm:ss");
          if (takeoff_time) takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
          if (landing_time) landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");
          if (engine_shutoff_time) engine_shutoff_time = moment(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");
      
          if (takeoff_time_scheduled) {
            let diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');
            if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
              if (engine_start_time) engine_start_time.add(1, 'd');
              if (takeoff_time) takeoff_time.add(1, 'd');
              if (landing_time) landing_time.add(1, 'd');
              if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
            }
          }
      
          if (takeoff_time > landing_time) {
            if (landing_time) landing_time.add(1, 'd');
          }
      
          if (engine_start_time > engine_shutoff_time) {
            if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
          }
      
          if (engine_start_time) engine_start_time = engine_start_time.format("YYYY-MM-DD HH:mm:ss");
          if (takeoff_time) takeoff_time = takeoff_time.format("YYYY-MM-DD HH:mm:ss");
          if (landing_time) landing_time = landing_time.format("YYYY-MM-DD HH:mm:ss");
          if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("YYYY-MM-DD HH:mm:ss");
          if (takeoff_time_scheduled) takeoff_time_scheduled = takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss");
      
          var datasave = {
            origin: 'Manual',
            id: self[ref].state.id,
            flight_report_id: self[ref].state.flight_report_id,
            leg_number: self[ref].state.leg_number,
            departure_location_id: self[ref].state.departure_location_id,
            arrival_location_id: self[ref].state.arrival_location_id,
            takeoff_time_scheduled: takeoff_time_scheduled,
            total_time_scheduled: self[ref].state.total_time_scheduled,
            engine_start_time: engine_start_time,
            takeoff_time: takeoff_time,
            landing_time: landing_time,
            engine_shutoff_time: engine_shutoff_time,
            takeoff_land_time: self[ref].state.takeoff_land_time,
            total_time: self[ref].state.total_time,
            navigation_time: self[ref].state.navigation_time,
            ifr_time: self[ref].state.ifr_time,
            night_time: self[ref].state.night_time,
            day_landings: self[ref].state.day_landings,
            night_landings: self[ref].state.night_landings,
            starts: self[ref].state.starts,
            pax: self[ref].state.pax,
            payload: self[ref].state.payload,
            external_load_long_line: self[ref].state.external_load_long_line,
            external_load_short_line: self[ref].state.external_load_short_line,
            fuel_start: self[ref].state.fuel_start,
            fuel_end: self[ref].state.fuel_end,
            ptbr_code_id: self[ref].state.ptbr_code_id,
            ptbr_operation_id: self[ref].state.ptbr_operation_id,
            ptbr_external_load_id: self[ref].state.ptbr_external_load_id,
            delay_time: self[ref].state.delay_time,
            delay_departure: self[ref].state.delay_departure,
          };
    
          data_legs.push(datasave);
          last_leg_number = parseInt(srl.leg_number) + 1;
        })}
        {Object.keys(self.state.flight_report_legs_new).map(function(k) {
          var srl = self.state.flight_report_legs_new[k];
          last_leg_number = parseInt(last_leg_number) + 1;
          var ref = 'child_leg_' + last_leg_number;
          let takeoff_time_scheduled = null;
          let engine_start_time = null;
          let takeoff_time = null;
          let landing_time = null;
          let engine_shutoff_time = null;
      
          if (self[ref].state.takeoff_time_scheduled) takeoff_time_scheduled = self[ref].state.date + ' ' + self[ref].state.takeoff_time_scheduled;
          if (self[ref].state.engine_start_time) engine_start_time = self[ref].state.date + ' ' + self[ref].state.engine_start_time;
          if (self[ref].state.takeoff_time) takeoff_time = self[ref].state.date + ' ' + self[ref].state.takeoff_time;
          if (self[ref].state.landing_time) landing_time = self[ref].state.date + ' ' + self[ref].state.landing_time;
          if (self[ref].state.engine_shutoff_time) engine_shutoff_time = self[ref].state.date + ' ' + self[ref].state.engine_shutoff_time;
      
          if (takeoff_time_scheduled) takeoff_time_scheduled = moment(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");
          if (engine_start_time) engine_start_time = moment(engine_start_time, "DD/MM/YYYY HH:mm:ss");
          if (takeoff_time) takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
          if (landing_time) landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");
          if (engine_shutoff_time) engine_shutoff_time = moment(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");
      
          if (takeoff_time_scheduled) {
            let diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');
            if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
              if (engine_start_time) engine_start_time.add(1, 'd');
              if (takeoff_time) takeoff_time.add(1, 'd');
              if (landing_time) landing_time.add(1, 'd');
              if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
            }
          }
      
          if (takeoff_time > landing_time) {
            if (landing_time) landing_time.add(1, 'd');
          }
      
          if (engine_start_time > engine_shutoff_time) {
            if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
          }
      
          if (engine_start_time) engine_start_time = engine_start_time.format("YYYY-MM-DD HH:mm:ss");
          if (takeoff_time) takeoff_time = takeoff_time.format("YYYY-MM-DD HH:mm:ss");
          if (landing_time) landing_time = landing_time.format("YYYY-MM-DD HH:mm:ss");
          if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("YYYY-MM-DD HH:mm:ss");
          if (takeoff_time_scheduled) takeoff_time_scheduled = takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss");
      
          var datasave = {
            origin: 'Manual',
            flight_report_id: self[ref].state.flight_report_id,
            leg_number: self[ref].state.leg_number,
            departure_location_id: self[ref].state.departure_location_id,
            arrival_location_id: self[ref].state.arrival_location_id,
            takeoff_time_scheduled: takeoff_time_scheduled,
            total_time_scheduled: self[ref].state.total_time_scheduled,
            engine_start_time: engine_start_time,
            takeoff_time: takeoff_time,
            landing_time: landing_time,
            engine_shutoff_time: engine_shutoff_time,
            takeoff_land_time: self[ref].state.takeoff_land_time,
            total_time: self[ref].state.total_time,
            navigation_time: self[ref].state.navigation_time,
            ifr_time: self[ref].state.ifr_time,
            night_time: self[ref].state.night_time,
            day_landings: self[ref].state.day_landings,
            night_landings: self[ref].state.night_landings,
            starts: self[ref].state.starts,
            pax: self[ref].state.pax,
            payload: self[ref].state.payload,
            external_load_long_line: self[ref].state.external_load_long_line,
            external_load_short_line: self[ref].state.external_load_short_line,
            fuel_start: self[ref].state.fuel_start,
            fuel_end: self[ref].state.fuel_end,
            ptbr_code_id: self[ref].state.ptbr_code_id,
            ptbr_operation_id: self[ref].state.ptbr_operation_id,
            ptbr_external_load_id: self[ref].state.ptbr_external_load_id,
            delay_time: self[ref].state.delay_time,
            delay_departure: self[ref].state.delay_departure,
          };
    
          data_legs.push(datasave);
        })}
        var data = {};
        data.flight_report_id = this.props.flight_report_id;
        data.legs = data_legs;
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/trecho/salvar/todos', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(data) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            responseJson.errors_save = false;

            if(responseJson.status === 'success') {
              localStorage.removeItem('cached_flight_report_legs_states_by_id');
              localStorage.removeItem('cached_flight_report_legs_states_new_by_id');
              self.setState({flight_report_legs_new: []});
  
              responseJson.errors_save = true;
            }

            if(responseJson.status === 'error') {
              responseJson.errors_save = true;
            }

            self.props.saveAllUpdate(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }

    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }
  }

  render() {
    var self = this;
    let start_parameter_total = null;
    let total = 1;
    let style = {
      form: {width: '100%', height: 'auto', overflowX: 'auto', whiteSpace: 'nowrap'},
      input_hour: {width: '75px', textAlign: 'center'},
      select_places: {width: '130px'},
      select_operation: {width: '240px'},
      input_number: {width: '70px', textAlign: 'center'},
      divs: {display: 'inline-block', marginRight: '15px'},
    };
    var define_leg_number = 0;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloCadastrarTrecho}</h3>
  <form onSubmit={this.addMobile} className="visible-xs">
    <hr />
    <div className="row">
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Origem}</label>
        <Select
          className="form-field-name"
          name="departure_location_id"
          value={this.state.departure_location_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'departure_location_id')}
          options={this.state.locations_select}
        />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Destino}</label>
        <Select
          className="form-field-name"
          name="arrival_location_id"
          value={this.state.arrival_location_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'arrival_location_id')}
          options={this.state.locations_select}
        />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Partida}</label>
        <InputMask value={this.state.engine_start_time}  maskChar={null} name="engine_start_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_start_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.DEC}</label>
        <InputMask value={this.state.takeoff_time}  maskChar={null} name="takeoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.POU}</label>
        <InputMask value={this.state.landing_time}  maskChar={null} name="landing_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'landing_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Corte}</label>
        <InputMask value={this.state.engine_shutoff_time}  maskChar={null} name="engine_shutoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_shutoff_time')} placeholder="" />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.DECPOU}</label>
        <InputMask value={this.state.takeoff_land_time}  maskChar={null} name="takeoff_land_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_land_time')} placeholder="" disabled  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Total}</label>
        <InputMask value={this.state.total_time}  maskChar={null} name="total_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'total_time')} placeholder="" disabled  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Nav}</label>
        <InputMask value={this.state.navigation_time}  maskChar={null} name="navigation_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'navigation_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.IFR}</label>
        <InputMask value={this.state.ifr_time}  maskChar={null} name="ifr_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'ifr_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Noturno}</label>
        <InputMask value={this.state.night_time}  maskChar={null} name="night_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'night_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Diurnos}</label>
        <input type="number" value={this.state.day_landings} name="day_landings " className="form-control" onChange={this.handleChange.bind(this, 'day_landings')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Noturnos}</label>
        <input type="number" value={this.state.night_landings} name="night_landings " className="form-control" onChange={this.handleChange.bind(this, 'night_landings')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Partidas}</label>
        <input type="number" value={this.state.starts} name="starts " className="form-control" onChange={this.handleChange.bind(this, 'starts')} placeholder="" />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.PAX}</label>
        <input type="number" value={this.state.pax} name="pax " className="form-control" onChange={this.handleChange.bind(this, 'pax')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Carga}</label>
        <input type="number" value={this.state.payload} name="payload " className="form-control" onChange={this.handleChange.bind(this, 'payload')} placeholder=""  />
      </div>

      {this.state.external_load == 1 ? 
        <div className="col-md-3 col-xs-6 form-group">
          <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.LongLine}</label>
          <br/>
          <Toggle
            checked={this.state.external_load_long_line}
            aria-label='No label tag'
            name="external_load_long_line"
            onChange={this.handleToggleChange.bind(this, 'external_load_long_line')} />
        </div>
        : ''
      }
      {this.state.external_load == 1 ? 
        <div className="col-md-3 col-xs-6 form-group">
          <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.ShortLine}</label>
          <br/>
          <Toggle
            checked={this.state.external_load_short_line}
            aria-label='No label tag'
            name="external_load_short_line"
            onChange={this.handleToggleChange.bind(this, 'external_load_short_line')} />
        </div>
      : ''
      }

      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Inicial}</label>
        <input type="number" value={this.state.fuel_start} name="fuel_start " className="form-control" onChange={this.handleChange.bind(this, 'fuel_start')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Final}</label>
        <input type="number" value={this.state.fuel_end} name="fuel_end " className="form-control" onChange={this.handleChange.bind(this, 'fuel_end')} placeholder=""  />
      </div>
      {this.state.xml == 1 ? 
        <div className="col-md-3 form-group">
          <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.CodigoPTBR} &nbsp;&nbsp;<button type="button" onClick={() => this.exportPtbrCode()} className="btn btn-success btn-xs"><i className="fa fa-fw fa-file-pdf-o"></i></button></label>
          <Select
            className="form-field-name"
            name="ptbr_code_id"
            value={this.state.ptbr_code_id}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChange.bind(this, 'ptbr_code_id')}
            options={this.state.ptbr_codes_select}
          />
        </div>
      : ''
      }
    </div>
    <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.botaoAdicionarTrecho}</button>
  </form>
  {/* <hr/>
  <button onClick={() => {self.saveAll()}} className="btn btn-success btn-block btn-lg"><i className="fa fa-save"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoSalvarTodos}</button> */}
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th colSpan={4}></th>
          <th colSpan={9} className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Realizados}</th>
          <th colSpan={2} className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Pousos}</th>
          <th colSpan={3} className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Dados}</th>
          {this.state.external_load == 1 ? 
            <th colSpan={2} className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.CargaExterna}</th>
          : ''
          }
          <th colSpan={2} className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Combustivel}</th>
          {this.state.xml == 1 ? 
            <th colSpan={1} className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.OperacaoPTBR} <button type="button" onClick={() => this.exportPtbrCode()} className="btn btn-success btn-xs"><i className="fa fa-fw fa-file-pdf-o"></i></button></th>
          : ''
          }
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Acoes}</th>
        </tr>
        <tr>
          <th className="text-center"></th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Numero}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Origem}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Destino}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Partida}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.DEC}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.POU}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Corte}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.DECPOU}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Total}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Nav}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.IFR}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Noturno}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Diurnos}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Noturnos}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Partidas}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.PAX}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Carga}</th>

          {this.state.external_load == 1 ? 
            <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.LongLine}</th>
          : ''
          }
          {this.state.external_load == 1 ? 
            <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.ShortLine}</th>
          : ''
          }
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Inicial}</th>
          <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Final}</th>
          {this.state.xml == 1 ? 
            <th className="text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.CodigoPTBR} </th>
          : ''
          }
          <th className="text-center" style={{width: '200px'}}></th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(self.state.flight_report_legs).map(function(k) {
          var srl = self.state.flight_report_legs[k];
          var flight_report_leg_edit = self.state.flight_report_legs[k];
          var cached_flight_report_legs_states_by_id = {};
          if (localStorage.getItem("cached_flight_report_legs_states_by_id")){
            cached_flight_report_legs_states_by_id = localStorage.getItem("cached_flight_report_legs_states_by_id");
            cached_flight_report_legs_states_by_id = JSON.parse(cached_flight_report_legs_states_by_id);
          }

          if(cached_flight_report_legs_states_by_id[srl.id]) {
            flight_report_leg_edit = cached_flight_report_legs_states_by_id[srl.id];
          }

          var last_index = (parseInt(k) - 1);
          if (typeof self.state.flight_report_legs[last_index] !== 'undefined') {
            if (self.state.flight_report_legs[last_index].engine_shutoff_time === null || self.state.flight_report_legs[last_index].engine_shutoff_time === '' || typeof self.state.flight_report_legs[last_index].engine_shutoff_time === 'undefined') {
              start_parameter_total = self.state.flight_report_legs[last_index].landing_time;
            }
          }
          var index = self.state.flight_report_legs.length;
          index--;
          let edit = false;
          if (parseInt(k) === index || srl.status === 'Incomplete') {
            edit = true;
          }
          var child_state = 'child_leg_' + srl.leg_number;
          define_leg_number = parseInt(srl.leg_number) + 1;

          return (
            <FlightReportLegEditTab ref={(leg_data) => {self[child_state] = leg_data}} external_load={self.state.external_load} xml={self.state.xml} updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} flight_report_leg_edit={flight_report_leg_edit} flight_report_leg_edit_staffs={srl.flight_report_leg_staffs} locations_select={self.state.locations_select} ptbr_codes_select={self.state.ptbr_codes_select} ptbr_operations_select={self.state.ptbr_operations_select} ptbr_external_loads_select={self.state.ptbr_external_loads_select} staffs_select={self.state.staffs_select} duties_select={self.state.duties_select} date={self.state.date} style={style} edit={edit} start_parameter_total={start_parameter_total} />
          );
        })}
        {self.state.status == 1 &&
          Object.keys(self.state.flight_report_legs_new).map(function(k) {
            define_leg_number = parseInt(define_leg_number) + 1;
            var flight_report_id = self.state.flight_report_id;
            var srl = self.state.flight_report_legs_new[k];
            var flight_report_leg_edit = self.state.flight_report_legs_new[k];
            var cached_flight_report_legs_states_new_by_id = {};
            if (localStorage.getItem("cached_flight_report_legs_states_new_by_id")) {
              cached_flight_report_legs_states_new_by_id = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id"));
              if (!cached_flight_report_legs_states_new_by_id[flight_report_id]) {
                cached_flight_report_legs_states_new_by_id[flight_report_id] = srl;
              }
            } else {
              cached_flight_report_legs_states_new_by_id[flight_report_id] = srl;
            }

            if(cached_flight_report_legs_states_new_by_id[flight_report_id][k]) {
              flight_report_leg_edit = cached_flight_report_legs_states_new_by_id[flight_report_id][k];
            }

            var last_index = (parseInt(k) - 1);
            if (typeof self.state.flight_report_legs_new[last_index] !== 'undefined') {
              if (self.state.flight_report_legs_new[last_index].engine_shutoff_time === null || self.state.flight_report_legs_new[last_index].engine_shutoff_time === '' || typeof self.state.flight_report_legs_new[last_index].engine_shutoff_time === 'undefined') {
                start_parameter_total = self.state.flight_report_legs_new[last_index].landing_time;
              }
            }
            var index = self.state.flight_report_legs_new.length;
            index--;
            let edit = false;
            if (parseInt(k) === index || srl.status === 'Incomplete') {
              edit = true;
            }
            var child_state = 'child_leg_' + define_leg_number;

            return (
              <FlightReportLegAddTab ref={(leg_data) => {self[child_state] = leg_data}} external_load={self.state.external_load} xml={self.state.xml} updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} flight_report_leg_edit={flight_report_leg_edit} flight_report_leg_edit_staffs={srl.flight_report_leg_staffs} locations_select={self.state.locations_select} ptbr_codes_select={self.state.ptbr_codes_select} ptbr_operations_select={self.state.ptbr_operations_select} ptbr_external_loads_select={self.state.ptbr_external_loads_select} staffs_select={self.state.staffs_select} duties_select={self.state.duties_select} date={self.state.date} style={style} edit={edit} start_parameter_total={start_parameter_total} flight_report_legs_states_new_index={k} setParentState={self.setParentState} setDeleteFalse={self.setDeleteFalse} deleting={self.state.deleting} flight_report_id={flight_report_id} />
            );
          })
        }
        {self.state.status == 1 &&
          <tr>
            <td style={{width: '200px', whiteSpace: 'nowrap'}}>
              <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.add()}}><i className="fa fa-plus"></i></button>
            </td>
            <td></td>
            <td>
              <Select
                className="form-field-name"
                style={style.select_places}
                name="departure_location_id"
                value={this.state.departure_location_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'departure_location_id')}
                options={this.state.locations_select}

              />
            </td>
            <td>
              <Select
                className="form-field-name"
                style={style.select_places}
                name="arrival_location_id"
                value={this.state.arrival_location_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'arrival_location_id')}
                options={this.state.locations_select}

              />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.engine_start_time}  maskChar={null} name="engine_start_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_start_time')} placeholder=""  />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.takeoff_time}  maskChar={null} name="takeoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_time')} placeholder=""  />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.landing_time}  maskChar={null} name="landing_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'landing_time')} placeholder=""  />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.engine_shutoff_time}  maskChar={null} name="engine_shutoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_shutoff_time')} placeholder="" />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.takeoff_land_time}  maskChar={null} name="takeoff_land_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_land_time')} placeholder="" disabled  />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.total_time}  maskChar={null} name="total_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'total_time')} placeholder="" disabled  />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.navigation_time}  maskChar={null} name="navigation_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'navigation_time')} placeholder=""  />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.ifr_time}  maskChar={null} name="ifr_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'ifr_time')} placeholder=""  />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.night_time}  maskChar={null} name="night_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'night_time')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.day_landings} name="day_landings " className="form-control" onChange={this.handleChange.bind(this, 'day_landings')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.night_landings} name="night_landings " className="form-control" onChange={this.handleChange.bind(this, 'night_landings')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.starts} name="starts " className="form-control" onChange={this.handleChange.bind(this, 'starts')} placeholder="" />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.pax} name="pax " className="form-control" onChange={this.handleChange.bind(this, 'pax')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.payload} name="payload " className="form-control" onChange={this.handleChange.bind(this, 'payload')} placeholder=""  />
            </td>
            {this.state.external_load == 1 ? 
              <td>
                <br/>
                <Toggle
                  checked={this.state.external_load_long_line}
                  aria-label='No label tag'
                  name="external_load_long_line"
                  onChange={this.handleToggleChange.bind(this, 'external_load_long_line')} />
              </td>

            : ''
            }
            {this.state.external_load == 1 ? 
              <td>
                <br/>
                <Toggle
                  checked={this.state.external_load_short_line}
                  aria-label='No label tag'
                  name="external_load_short_line"
                  onChange={this.handleToggleChange.bind(this, 'external_load_short_line')} />
              </td>
            : ''
            }
            <td>
              <input style={style.input_number} type="number" value={this.state.fuel_start} name="fuel_start " className="form-control" onChange={this.handleChange.bind(this, 'fuel_start')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.fuel_end} name="fuel_end " className="form-control" onChange={this.handleChange.bind(this, 'fuel_end')} placeholder=""  />
            </td>
            {this.state.xml == 1 ? 
              <td>
                <Select
                  className="form-field-name"
                  name="ptbr_code_id"
                  value={this.state.ptbr_code_id}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'ptbr_code_id')}
                  options={this.state.ptbr_codes_select}
                  style={style.select_operation}
                />
              </td>
            : ''
            }
            <td style={{width: '200px', whiteSpace: 'nowrap', textAlign: 'center'}}>
              <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.add()}}><i className="fa fa-fw fa-plus"></i></button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <hr/>
  <button onClick={() => {self.saveAll()}} className="btn btn-success btn-block btn-lg"><i className="fa fa-save"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoSalvarTodos}</button>
  <hr/>
  <h4 className="page-title">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloTotaisDosTrechos}</h4>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.DecolagemPouso}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.TempoTotal}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Navegacao}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Instrumento}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Noturno}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.PousosDiurnos}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.PousosNoturnos}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Pax}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Carga}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Consumo}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{self.state.flight_report_legs_totals.takeoff_land_time_total}</td>
          <td>{self.state.flight_report_legs_totals.time_total}</td>
          <td>{self.state.flight_report_legs_totals.navigation_total}</td>
          <td>{self.state.flight_report_legs_totals.ifr_total}</td>
          <td>{self.state.flight_report_legs_totals.night_total}</td>
          <td>{self.state.flight_report_legs_totals.day_landings_total}</td>
          <td>{self.state.flight_report_legs_totals.night_landings_total}</td>
          <td>{self.state.flight_report_legs_totals.pax_total}</td>
          <td>{self.state.flight_report_legs_totals.payload_total}</td>
          <td>{self.state.flight_report_legs_totals.fuel_total}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default FlightReportLegsTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportLegsTab.js